module.exports = __webpack_public_path__ + "lui-icons.ttf";